export const MAPS_CONFIG = {
  YANDEX_MAPS_API_KEY: "7e559dda-c37f-429e-9471-5f3c013e4e6e",
  DEFAULT_ZOOM: 15,
  DEFAULT_CONTROLS: ["zoomControl", "fullscreenControl"],
};
